import * as React from 'react';
import { classes } from './image-component.st.css';
import { getImageURL } from '../../../../services/get-image-url';
export function ImageComponent(props) {
  const {
    imageResize = 'cover',
    imageAlignment = 'center'
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.imageContainer,
    style: {
      paddingTop: `${1 / props.aspectRatio * 100}%`
    }
  }, props.image ? /*#__PURE__*/React.createElement("img", {
    alt: props.alt,
    className: classes.image,
    style: {
      objectPosition: imageAlignment,
      objectFit: imageResize
    },
    width: "100%",
    height: "100%",
    src: getImageURL(props.image, props.image.width, props.image.height)
  }) : null);
}
//# sourceMappingURL=image-component.js.map